import { RouteReuseStrategy } from '@angular/router/';
import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class TmvRouteReuseStrategy implements RouteReuseStrategy {

  private storedRoutes = new Map<string, DetachedRouteHandle>();

  //leave route, true: store route
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // console.log('leave route: should detach? ' + route)
    return route.data.shouldReuse || false;
  }

  //if shouldDetach
  store(route: ActivatedRouteSnapshot, handle: {}): void {
    //console.log('store route: ' + route + ' ' + handle);
    this.storedRoutes.set(route.routeConfig.path, handle);
  }

  //on landing, false: component from scratch
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // console.log('route landing: should attach? ' + route);
    return (route.data.shouldReuse) ? this.storedRoutes.has(this.getPath(route)) : false;
  }

  //if shouldattach, returns stored routehandler
  retrieve(route: ActivatedRouteSnapshot): {} {
    //console.log('retrieve.. . ' + route);
    return (route.data.shouldReuse) ? this.storedRoutes.get(this.getPath(route)) as DetachedRouteHandle : null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    //  console.log('future: ' + future + '           curr:  ' + curr + '   result: ' + (future.routeConfig === curr.routeConfig))
    return future.routeConfig === curr.routeConfig;
  }

  private getPath(route: ActivatedRouteSnapshot): string {
    if (route.routeConfig !== null && route.routeConfig.path !== null) {
      return route.routeConfig.path;
    }
    return '';
  }
}